import { render, staticRenderFns } from "./MenuLists.vue?vue&type=template&id=86e6a854&scoped=true&"
import script from "./MenuLists.vue?vue&type=script&lang=js&"
export * from "./MenuLists.vue?vue&type=script&lang=js&"
import style0 from "./MenuLists.vue?vue&type=style&index=0&id=86e6a854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e6a854",
  null
  
)

export default component.exports